var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.descTemplate)?_c('div',{staticClass:"instype-result-wrap"},[_c('contrast-liability',{attrs:{"temp":_vm.descTemplate,"data":_vm.descData,"profit-btn":_vm.propProfit},on:{"disShow":_vm._fetchDisData}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }